import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import TDesign from "tdesign-vue-next";
import { DialogPlugin } from "tdesign-vue-next";
import { doLoginLog, getTenantIdDomain } from "@/api/login";
import { MessagePlugin } from "tdesign-vue-next";

import vue3TreeOrg from "vue3-tree-org";
import "vue3-tree-org/lib/vue3-tree-org.css";

import ElementPlus from "element-plus";
// element-plus  国际化
import enLocale from "element-plus/es/locale/lang/en";
import zhLocale from "element-plus/es/locale/lang/zh-cn";
let locale = {};
window.g.LANG;
if (window.g.LANG == "zh" || window.g.LANG == undefined) {
  locale = zhLocale;
} else {
  locale = enLocale;
}

import "dayjs/locale/zh-cn";
// import App from './App.vue'
import DOMPurify from "dompurify";

import mitt from "mitt";
// iconfont
import "./iconfont_svn/iconfont";
import "./iconfont_svn/iconfont.css";
// 样式
import "./style/common.css";
import "./style/VarCss.css";
import "./style/commonStyle.css";

import i18n from "@/utils/i18n";
import { resolveModuleTitle } from "@/utils/moduleTitle";

// 路由守卫
import "./utils/before";

import { getAppLiveInfo } from "@/api/App.js";
import { getExternalInfoServer } from "@/utils/handleUrl.js";

const app = createApp(App);
app.config.globalProperties.$eventBus = mitt();
app
  .use(i18n)
  .use(store)
  .use(router)
  .use(TDesign)
  .use(vue3TreeOrg)
  .use(ElementPlus, { locale })
  .mount("#app");

//v-html 安全处理 防止xss 脚本攻击
app.directive("purify-html", {
  // 再绑定时执行 只调用一次
  beforeMount: (el, binding) => {
    // el元素 dom操作可读可写 binding（只读）：通过自定义指令传递的参数都在这里 vnode（只读）：Vue编译生成的虚拟节点。
    console.log(binding);
    let clean = DOMPurify.sanitize(binding.value);
    // px 转成rem布局
    // clean = clean.replace(/(\d+)px/g, function(s, t) {
    //     s = s.replace('px', '');
    //     var value = parseInt(s) * 0.0000000001; // 100px = 1rem
    //     return value + "rem"; //0.23rem
    // });
    el.innerHTML = clean;
  },
});

// 将学校id每次都存放在vuex中
import Cookies from "js-cookie";
if (!Cookies.get("schoolId")) {
  getTenantIdDomain(window.location.host).then((res) => {
    if (res.code == "1" && res.data) {
      Cookies.set("schoolId", res.data);
      store.commit("setSchoolId", res.data);
      // 特殊私有化部署 处理
      getExternalInfoServer();
    } else {
      console.log("域名获取到学校id报错了", res.msg);
    }
  });
}else{
  // 特殊私有化部署 处理
  getExternalInfoServer();
}


// 将学校id每次都存放在vuex中
if (Cookies.get("schoolId")) {
  const savedData = Cookies.get("schoolId");
  store.commit("setSchoolId", savedData);
}
import { flag } from "@/utils/handleUrl.js";
// 白名单
const whiteList = [
  "/lengthen",
  "/login",
  "/SSO",
  "/Wenxiang_H5Login",
  "/qrlogin",
  "/register",
  "/qrRegister",
  "/liveSharing",
  "/appDefaultPage",
  "/activation",
  "/wenxiang/extendAuthorization",
  "/awaitPage",
];


// 登录日志计数器，防止重复调用
let count = 0;

// console.log(i18n(),'+++++++');
router.beforeEach((to, from, next) => {
  const getToken = Cookies.get("tokenValue");
  // 全局设置 平台设置 个性化设置 登录设置 权限字段
  const logingSeting = sessionStorage.getItem("logingSeting");
  

  // 返回阻断弹窗 使用时按需配置这俩字段
  // window.DialogPluginTxt = `退出页面后，已编辑的内容将丢失。确定退出页面吗？`
  // window.BtnStayPage = `留在页面`
  // window.BtnExitPage = `退出页面`
  if (window.DialogPlugin) {
    // 阻断弹窗
    const confirmDia = DialogPlugin.confirm({
      header: window.DialogPluginTxt,
      theme: "warning",
      closeBtn: false,
      confirmBtn: window.BtnStayPage,
      cancelBtn: window.BtnExitPage,
      placement: "top",
      width: 369,
      onConfirm: () => {
        confirmDia.hide();
      },
      onClose: ({ e, trigger }) => {
        confirmDia.hide();
        window.DialogPlugin = false;
        next();
      },
    });
    return;
  }
  // 检测设备类型并设置标题
  function setDocumentTitle() {
    const userAgent = navigator.userAgent.toLowerCase();
    let title = "智慧课堂";

    if (
      userAgent.includes("mobile") ||
      userAgent.includes("iphone") ||
      userAgent.includes("android")
    ) {
      // 移动端设为空
      title = "";
      document.title = title;
    }
    // else {
    // if (window.g.LANG == "zh") {
    //   title = "智慧课堂";
    // } else {
    //   title = "Wisdom Classroom";
    // }
    // }
  }

  setDocumentTitle();
  // 判断是否为手机分享路由，根据设备型号跳转PC详情页
  if (to.path === "/liveSharing") {
    const query = window.location.search.substring(1);
    const queryArr = query.split("_"); // url参数：学校id 业务id 业务类型
    var reg = new RegExp("=", "g");
    const type = queryArr[2].replace(reg, ""); // 业务类型 --- 1:精品课 2:直播 3:课例评课 4:教研直播 5:教研互动 6:系列课 7:远程互动
    store.commit("setSchoolId", queryArr[0]);
    if (flag()) {
      // 移动端
      next();
    } else {
      // pc端
      getAppLiveInfo({
        schoolId: queryArr[0],
        id: queryArr[1],
        type: type,
      }).then((res) => {
        if (res.code === 1) {
          const data = res.data; // 详情接口数据
          console.log("分享-详情数据", data);
          switch (type) {
            case "1":
              next({
                path: "/wenxiang/ExcellentCourseLi",
                query: {
                  id: data.id,
                  navName: resolveModuleTitle("精品课程"),
                },
              });
              // console.log("精品课");
              break;
            case "2":
              // 回放
              if (data.liveStatus == 2) {
                next({
                  path: "/wenxiang/courseDetails",
                  query: {
                    id: data.id,
                    type: "1", //直播传1
                    navName: resolveModuleTitle("在线课堂"),
                    liveType: "2", //liveType 2回放  1未结束的直播
                  },
                });
              } else {
                next({
                  path: "/wenxiang/courseDetails",
                  query: {
                    id: data.id,
                    type: "1", //直播传1
                    navName: resolveModuleTitle("在线课堂"),
                    liveType: "1", //liveType 2回放  1未结束的直播
                  },
                });
              }
              break;
            case "3":
              next({
                path: "/wenxiang/TeachingActivities_VeiwDetail",
                query: {
                  id: data.id,
                  typeState: 1, // 1课例评课 2直播教研 3互动教研
                },
              });
              // console.log("课例评课");
              break;
            case "4":
              next({
                path: "/wenxiang/TeachingActivities_VeiwDetail",
                query: {
                  id: data.id,
                  typeState: 2, // 1课例评课 2直播教研 3互动教研
                },
              });
              // console.log("教研直播");
              break;
            case "5":
              next({
                path: "/wenxiang/TeachingActivities_VeiwDetail",
                query: {
                  id: data.id,
                  typeState: 3, // 1课例评课 2直播教研 3互动教研
                },
              });
              // console.log("教研互动");
              break;
            case "6":
              next({
                path: "/wenxiang/SeriesCourseLiInfo",
                query: {
                  id: data.id,
                  navName: resolveModuleTitle("系列课程"),
                },
              });
              console.log("系列课");
              break;
            case "7":
              console.log("远程互动");
              next({
                path: "/wenxiang/DeliveryClassroom_VeiwDetail",
                query: {
                  id: data.id,
                  courseSectionId: queryArr[1],
                },
              });
              break;
            default:
              console.log("请检查直播类型");
              break;
          }
        } else {
          next({ path: "/" });
        }
      });
    }
    return;
  }
  if(getToken){
    if (count == 0 && Cookies.get("logId")) {
      doLoginLog(Cookies.get("logId"), 2);
      count++;
    }
  }
  if (whiteList.includes(to.path)) {
    // // 如果用户已登录，且当前页面是登录页面，则跳转到主页
    if (getToken) {
      // if (count == 0 && Cookies.get("logId")) {
      //   doLoginLog(Cookies.get("logId"), 2);
      //   count++;
      // }
      if (flag()) {
        // 移动端
        next();
      } else {
        // pc端
        next({ path: "/" });
      }
    } else {
      next(); // 继续路由导航
    }
  }else if(logingSeting == 3){
    // 必须登录
    // 全局设置 平台设置 个性化设置 登录设置 权限字段
    if (!getToken) {
      next({ path: "/login" });
    } else {
      next(); // 继续路由导航
    }
  } else if (to.meta.skip_login === true) {
    next(); // 继续路由导航
  } else {
    if (!getToken) {
      next({ path: "/login" });
    } else {
      next(); // 继续路由导航
    }
  }
});
console.log('构建时间：', _BUILD_TIME_,'构建版本：', _BUILD_VERSION_)